import React, { FC } from 'react';

type TProps = {
    clr:string;
    opacity?: string;
    onClick?: any;
}

export const ArrowCornerSvg: FC<TProps> = ({ clr, opacity, onClick }) => {

    return (
    <svg className='corner-svg' width="16" height="16" viewBox="0 0 18 18" fill={clr} onClick={() => onClick ? onClick() : false } xmlns="http://www.w3.org/2000/svg">
        <g opacity={opacity ? opacity : "0.3"}>
            <path d="M0.823305 15.2025C0.776371 15.2494 0.75 15.313 0.75 15.3794C0.75 15.4457 0.776371 15.5093 0.823305 15.5562L2.44542 17.1769C2.54304 17.2744 2.7012 17.2744 2.79882 17.1769L14.4938 5.49266L14.4938 14.2302C14.4938 14.2968 14.5203 14.3606 14.5676 14.4076C14.6148 14.4545 14.6788 14.4806 14.7454 14.4802L17.0016 14.4655C17.1391 14.4646 17.25 14.3529 17.25 14.2155L17.25 1.01473C17.25 0.876769 17.1382 0.764886 17.0003 0.764732L3.77263 0.75C3.706 0.749926 3.64209 0.776455 3.5951 0.823696C3.54811 0.870938 3.52193 0.934984 3.52236 1.00161L3.5371 3.28522C3.53799 3.42282 3.6499 3.53383 3.78749 3.53361L12.5168 3.51983L0.823305 15.2025Z" fill={clr} stroke="#909090" strokeWidth="0.5" strokeLinejoin="round"/>
        </g>
    </svg>
    )
}

import React, { FC } from 'react';

type TProps = {
    clr:string;
    opacity?: string;
    onClick?: any;
}

export const ArrowCornerSvg: FC<TProps> = ({ clr, opacity, onClick }) => {

    return (
    <svg className='corner-svg' width="16" height="16" viewBox="0 0 18 18" fill={clr} onClick={() => onClick ? onClick() : false } xmlns="http://www.w3.org/2000/svg">
        <g opacity={opacity ? opacity : "0.3"}>
            <path d="M0.823305 15.2025C0.776371 15.2494 0.75 15.313 0.75 15.3794C0.75 15.4457 0.776371 15.5093 0.823305 15.5562L2.44542 17.1769C2.54304 17.2744 2.7012 17.2744 2.79882 17.1769L14.4938 5.49266L14.4938 14.2302C14.4938 14.2968 14.5203 14.3606 14.5676 14.4076C14.6148 14.4545 14.6788 14.4806 14.7454 14.4802L17.0016 14.4655C17.1391 14.4646 17.25 14.3529 17.25 14.2155L17.25 1.01473C17.25 0.876769 17.1382 0.764886 17.0003 0.764732L3.77263 0.75C3.706 0.749926 3.64209 0.776455 3.5951 0.823696C3.54811 0.870938 3.52193 0.934984 3.52236 1.00161L3.5371 3.28522C3.53799 3.42282 3.6499 3.53383 3.78749 3.53361L12.5168 3.51983L0.823305 15.2025Z" fill={clr} stroke="#909090" strokeWidth="0.5" strokeLinejoin="round"/>
        </g>
    </svg>
    )
}

